import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../assets/css/Mitsubishi.css";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";

function Mitsubishi() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Mitsubishi Industrial Automation Solutions | Skimitar Automation
        </title>
        <meta
          name="description"
          content="Explore our comprehensive range of Mitsubishi industrial automation products including PLCs, HMIs, VFDs, and SCADA systems at Skimitar Automation."
        />
      </Helmet>

      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <h1 className="display-3 text-white animated slideInRight">
            Mitsubishi
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animated slideInRight mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">Products</li>
              <li className="breadcrumb-item active" aria-current="page">
                Mitsubishi
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="pe-lg-4">
                <div className=" border-danger border-4 mb-4">
                  <span className="text-uppercase fw-bold text-secondary">
                    Trusted Partnership
                  </span>

                  <div className="section-header mb-4">
                    <h1 className="section-title  display-5 fw-bold text-red">
                      Mitsubishi <span className="text-yellow">Solutions</span>
                    </h1>
                  </div>
                </div>
                <p className="fs-6 mb-4">
                  <span className="fw-semibold">
                    Skimitar Hindusthan Pvt Ltd
                  </span>{" "}
                  is a trusted provider of Mitsubishi Electric industrial
                  automation solutions, offering advanced products known for
                  reliability, efficiency, and innovative technology. As a
                  technology partner, we deliver high-performance automation
                  systems and engineering services that help industries optimize
                  operations, reduce downtime, and improve productivity. Our
                  expertise in Mitsubishi automation technologies enables
                  businesses to achieve sustainable growth and operational
                  excellence in modern manufacturing environments.
                </p>
                {/* <p className="fs-6 mb-4 justified-text">
                  Our partnership with Mitsubishi allows us to deliver
                  cutting-edge technologies that help our clients optimize their
                  operations, reduce downtime, and achieve sustainable growth in
                  competitive markets.
                </p> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="position-relative">
                <img
                  className="Digitalization rounded-3 mx-4"
                  src={require("../assets/img/products/Mitsubishi/Mitsubishi Solutions.png")}
                  alt="Mitsubishi Automation Systems"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Categories Tabs */}
      <section className="bg-light py-5">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-up">
            <h2
              className="text-gradient-primary fw-bold mb-4"
              data-aos="fade-left"
            >
              Complete Automation Solutions
            </h2>
          </div>

          <div className="row g-4">
            {/* PLC Card */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up">
              <div className="card product-card h-100 border-0 shadow-sm">
                <div className="product-image-container">
                  <img
                    src={require("../assets/img/products/Mitsubishi/logic-controller.png")}
                    style={{ height: "400px" }}
                    className="card-img-top"
                    alt="Mitsubishi PLC"
                  />
                </div>
                <div className="card-body">
                  <h3 className="card-title h4 fw-bold text-danger">
                    Logic Controllers
                  </h3>

                  <p className="card-text fs-6 justified-text">
                    High-speed, precise control solutions for diverse automation
                    applications with modular and scalable architecture for
                    evolving industrial needs.
                  </p>
                </div>
              </div>
            </div>

            {/* HMI Card */}
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="card product-card h-100 border-0 shadow-sm">
                <div className="product-image-container">
                  <img
                    // src={require("../assets/img/products/Mitsubishi/hmi.jpg")}
                    src={require("../assets/img/products/Mitsubishi/human-interface.png")}
                    style={{ height: "400px" }}
                    className="card-img-top"
                    alt="Mitsubishi HMI"
                  />
                </div>
                <div className="card-body">
                  <h3 className="card-title h4 fw-bold text-danger">
                    Human-Machine Interface
                  </h3>
                  <p className="card-text fs-6 justified-text">
                    Intuitive touch-screen interfaces with vibrant displays that
                    enhance operator control and provide real-time visualization
                    of industrial processes.
                  </p>
                </div>
              </div>
            </div>

            {/* VFD Card */}
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="card product-card h-100 border-0 shadow-sm">
                <div className="product-image-container">
                  <img
                    src={require("../assets/img/products/Mitsubishi/Variable Frequency Drives.png")}
                    style={{ height: "400px" }}
                    className="card-img-top"
                    alt="Mitsubishi VFD"
                  />
                </div>
                <div className="card-body">
                  <h3 className="card-title h4 fw-bold text-danger">
                    Variable Frequency Drives
                  </h3>
                  <p className="card-text fs-6 justified-text">
                    Energy-efficient motor control systems offering precise
                    speed and torque regulation for optimal performance and
                    reduced operational costs.
                  </p>
                </div>
              </div>
            </div>

            {/* SCADA Card */}
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="card product-card h-100 border-0 shadow-sm">
                <div className="product-image-container">
                  <img
                    src={require("../assets/img/products/Mitsubishi/SCADA Systems (2).png")}
                    style={{ height: "400px" }}
                    className="card-img-top"
                    alt="Mitsubishi SCADA"
                  />
                </div>
                <div className="card-body">
                  <h3 className="card-title h4 fw-bold text-danger">
                    SCADA Systems
                  </h3>
                  <p className="card-text fs-6 justified-text">
                    Comprehensive monitoring and control platforms that provide
                    complete visibility over industrial processes for informed
                    decision
                  </p>
                </div>
              </div>
            </div>

            {/* Servo Systems Card */}
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="card product-card h-100 border-0 shadow-sm">
                <div className="product-image-container">
                  <img
                    src={require("../assets/img/products/Mitsubishi/Servo Systems High.png")}
                    style={{ height: "400px" }}
                    className="card-img-top"
                    alt="Mitsubishi Servo Systems"
                  />
                </div>
                <div className="card-body">
                  <h3 className="card-title h4 fw-bold text-danger">
                    Servo Systems
                  </h3>
                  <p className="card-text fs-6 justified-text">
                    High-precision motion control solutions offering exceptional
                    accuracy, responsiveness, and reliability for demanding
                    applications.
                  </p>
                </div>
              </div>
            </div>

            {/* Robotics Card */}
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="card product-card h-100 border-0 shadow-sm">
                <div className="product-image-container">
                  <img
                    src={require("../assets/img/products/Mitsubishi/Industrial Robotics Advanced.png")}
                    style={{ height: "400px" }}
                    className="card-img-top"
                    alt="Mitsubishi Robotics"
                  />
                </div>
                <div className="card-body">
                  <h3 className="card-title h4 fw-bold text-danger">
                    Industrial Robotics
                  </h3>
                  <p className="card-text fs-6 justified-text">
                    Advanced robotic solutions for automation, featuring
                    seamless integration with other Mitsubishi products for
                    enhanced productivity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PLC Section with Detailed Information */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2" data-aos="fade-left">
              <div className="ps-lg-4">
                <div className="section-header mb-4">
                  <h2 className="section-title  display-5 fw-bold text-danger">
                    Programmable{" "}
                    <span className="text-dark">Logic Controllers</span>
                  </h2>
                </div>
                <p className="fs-6 mb-4 justified-text">
                  Mitsubishi PLCs are engineered to deliver high-speed, precise
                  control for diverse automation applications. Their robust
                  architecture allows for seamless integration with existing
                  systems, making them ideal for everything from simple tasks to
                  complex manufacturing processes.
                </p>

                <div className="row g-4 mb-4">
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div className="feature-icon bg-danger text-white rounded-circle p-3 me-3">
                        <i className="fas fa-microchip"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold">Modular Design</h4>
                        <p className="fs-6 ">
                          Expandable systems that grow with your needs
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div className="feature-icon bg-danger text-white rounded-circle p-3 me-3">
                        <i className="fas fa-bolt"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold">High-Speed</h4>
                        <p className="fs-6">
                          Rapid response times for critical applications
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div className="feature-icon bg-danger text-white rounded-circle p-3 me-3">
                        <i className="fas fa-network-wired"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold">Connectivity</h4>
                        <p className="fs-6">
                          Multiple protocol support for easy integration
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div className="feature-icon bg-danger text-white rounded-circle p-3 me-3">
                        <i className="fas fa-shield-alt"></i>
                      </div>
                      <div>
                        <h4 className="h5 fw-bold">Enhanced Security</h4>
                        <p className="fs-6">
                          Built-in protection against unauthorized access
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1" data-aos="zoom-in">
              <div className="position-relative">
                <img
                  className="img-fluid rounded shadow"
                  style={{ objectFit: "cover" }}
                  src={require("../assets/img/products/Mitsubishi/Programmable Logic Controllers.png")}
                  alt="Mitsubishi PLC"
                />
                {/* <div className="experience-badge experience-badge-alt">
                  <span className="h2 fw-bold">iQ-R</span>
                  <span className="d-block">Series</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HMI & SCADA Section */}
      <section className="bg-light py-5">
        <div className="container">
          {/* <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="display-5 fw-bold">Control & Monitoring Systems</h2>
          </div> */}
          <div className="text-center mb-5" data-aos="fade-up">
            <h2
              className="text-gradient-primary fw-bold mb-4"
              data-aos="fade-left"
            >
              Control Monitoring Systems
            </h2>
          </div>

          <div className="row g-4">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <h4 className="card-title h3 fw-bold text-danger mb-3">
                    Human-Machine Interface
                  </h4>
                  <p className="card-text fs-6 mb-4">
                    Mitsubishi HMIs provide intuitive and visually engaging
                    interfaces that empower operators to monitor and control
                    industrial processes with ease. With high-resolution touch
                    screens and customizable graphics, these HMIs enhance user
                    interaction, enabling quick decision-making and efficient
                    operations.
                  </p>

                  <div className="row mb-4">
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dark me-2"></i>
                        <span className="fs-6">Responsive Touch Screens</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dark me-2"></i>
                        <span className="fs-6">Vibrant Color Displays</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dark me-2"></i>
                        <span className="fs-6">Intuitive User Interface</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dark me-2"></i>
                        <span className="fs-6">Multi-language Support</span>
                      </div>
                    </div>
                  </div>

                  <img
                    className="img-fluid rounded mb-4"
                    src={require("../assets/img/products/Mitsubishi/human interface two.png")}
                    style={{ height: "300px", width: "100%" }}
                    alt="Mitsubishi HMI Interface"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <h4 className="card-title h3 fw-bold text-danger mb-3">
                    SCADA Systems
                  </h4>
                  <p className="card-text fs-6 mb-5">
                    Mitsubishi SCADA systems provide comprehensive monitoring
                    and control capabilities for industrial processes. By
                    integrating SCADA with PLCs and HMIs, you gain complete
                    visibility over your processes, facilitating informed
                    decision-making and improved responsiveness.
                  </p>

                  <div className="row mt-4 mb-4">
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dark me-2"></i>
                        <span className="fs-6">Real-time Data</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dark me-2"></i>
                        <span className="fs-6">Analysis</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dakr me-2"></i>
                        <span className="fs-6">Reporting</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-dark me-2"></i>
                        <span className="fs-6">Efficiency</span>
                      </div>
                    </div>
                  </div>
                  <img
                    className="img-fluid rounded mb-4"
                    src={require("../assets/img/products/Mitsubishi/SCADA Systems.png")}
                    style={{ height: "300px", width: "100%" }}
                    alt="Mitsubishi SCADA Interface"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VFD Parallax Section */}
      <section className="vfd-parallax-section py-5">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-lg-6 text-center mt-5">
              <img
                alt=""
                src={require("../assets/img/products/Mitsubishi/Variable Frequency Drives Designed.png")}
                style={{ width: "100%", height: "400px" }}
              ></img>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div
                className="card  p-4 shadow"
                style={{ backgroundColor: "#E9ECEF" }}
              >
                <div className="card-body">
                  {/* <h4 className="card-title fs-2 fw-bold text-danger mb-4">
                    Variable Frequency Drives
                  </h4> */}
                  <div className="section-header mb-4">
                    <h2 className="section-title text-danger">
                      Variable{" "}
                      <span className="text-dark">Frequency Drives</span>
                    </h2>
                  </div>
                  <p className="card-text fs-6 mb-4 justified-text">
                    Designed to optimize motor control, Mitsubishi VFDs offer
                    precise speed and torque regulation, resulting in
                    significant energy savings and enhanced performance. These
                    drives are ideal for a wide array of applications, from HVAC
                    systems to conveyor belts.
                  </p>
                  <p className="card-text fs-6 mb-4 justified-text">
                    By reducing wear and tear on equipment, Mitsubishi VFDs help
                    extend the lifespan of your machinery, making them a smart
                    investment for your operations.
                  </p>

                  <div className="row mb-4">
                    <div className="col-md-6 mb-3">
                      <div className="vfd-feature-item">
                        <i className="fas fa-leaf text-danger me-2"></i>
                        <span className="fs-6">Energy Savings up to 60%</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="vfd-feature-item">
                        <i className="fas fa-cog text-danger me-2"></i>
                        <span className="fs-6">Extended Equipment Life</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="vfd-feature-item">
                        <i className="fas fa-sliders-h text-danger me-2"></i>
                        <span className="fs-6">Precise Control</span>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="vfd-feature-item">
                        <i className="fas fa-plug text-danger me-2"></i>
                        <span className="fs-6">Reduced Startup Current</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="bg-light py-5">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-up">
            <h4 className="fs-2 text-danger">
              Industries <span className="text-dark">We Serve</span>{" "}
            </h4>
          </div>

          <div className="row g-4 text-center">
            <div className="col-md-3 col-sm-6" data-aos="fade-up">
              <div className="industry-card">
                <div className="industry-icon">
                  <i className="fas fa-industry text-danger"></i>
                </div>
                <h3 className="h4 fw-bold">Manufacturing</h3>
                <p className="fs-6 justified-text">
                  Streamline production lines, enhance quality control, and
                  optimize manufacturing processes with advanced automation
                  solutions.
                </p>
              </div>
            </div>

            <div
              className="col-md-3 col-sm-6"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="industry-card">
                <div className="industry-icon">
                  <i className="fas fa-oil-can text-danger"></i>
                </div>
                <h3 className="h4 fw-bold">Oil & Gas</h3>
                <p className="fs-6 justified-text">
                  Ensure safety, reliability, and efficiency in extraction,
                  processing, and distribution operations with robust control
                  systems.
                </p>
              </div>
            </div>

            <div
              className="col-md-3 col-sm-6"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="industry-card">
                <div className="industry-icon">
                  <i className="fas fa-water text-danger"></i>
                </div>
                <h3 className="h4 fw-bold">Water & Wastewater</h3>
                <p className="fs-6 justified-text">
                  Monitor and control treatment processes, pumping stations, and
                  distribution networks with precision and reliability.
                </p>
              </div>
            </div>

            <div
              className="col-lg-3 col-sm-6"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="industry-card">
                <div className="industry-icon">
                  <i className="fas fa-bolt text-danger"></i>
                </div>
                <h3 className="h4 fw-bold">Power Generation</h3>
                <p className="fs-6 justified-text">
                  Optimize energy production, distribution, and consumption with
                  integrated control and monitoring systems.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="container py-5">
        <div class="row g-4">
          <div class="col-lg-3 col-md-6">
            <div class="service-card">
              <div class="service-icon text-center">
                <i class="bi bi-gear-wide-connected "></i>
              </div>
              <h3 class="service-title">Industrial Ideas</h3>
              <p class="service-text fs-6">
                The printing and typesetting industry. Lorem Ipsum has been the
                industry's standard.
              </p>
              <div class="bg-shape">⚙</div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="service-card">
              <div class="service-icon text-center">
                <i class="bi bi-person-gear"></i>
              </div>
              <h3 class="service-title">Expert Engineers</h3>
              <p class="service-text fs-6">
                All the Lorem Ipsum generators on the Internet tend to repeat
                predefined chunks.
              </p>
              <div class="bg-shape">👷</div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="service-card">
              <div class="service-icon text-center">
                <i class="bi bi-robot"></i>
              </div>
              <h3 class="service-title">Modern Equipment</h3>
              <p class="service-text fs-6">
                Many desktop publishing and web page editors now use Lorem Ipsum
                as their default.
              </p>
              <div class="bg-shape">🦾</div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6">
            <div class="service-card">
              <div class="service-icon text-center">
                <i class="bi bi-headset"></i>
              </div>
              <h3 class="service-title">Project Support</h3>
              <p class="service-text fs-6">
                More-or-less normal letters as opposed to using 'Content here,
                content here.
              </p>
              <div class="bg-shape">💬</div>
            </div>
          </div>
        </div>
      </div>

      {/* //////////////////////////////////////////////////////////////////////////// */}

      <div className="container">
        <div className="row">
          <div className="col-lg-6"></div>
          <div className="col-lg-6"></div>
        </div>
      </div>
    </>
  );
}

export default Mitsubishi;
